import OtpTextField from './OtpTextField';

export default OtpTextField;
